import { Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import SubmitPage from './pages/SubmitPage'
import SubmitSuccessPage from './pages/SubmitSuccessPage'
import VoteRequestPage from './pages/VoteRequestPage'
import VotePage from './pages/VotePage'
import VoteSuccessPage from './pages/VoteSuccessPage'
import EloVotingPage from './pages/EloVotingPage'
import WinnersPage from './pages/WinnersPage'
import AdminLoginPage from './pages/admin/AdminLoginPage'
import AdminDashboardPage from './pages/admin/AdminDashboardPage'
import { FeedbackProvider } from './components/ui/feedback'

export default function App() {
  return (
    <FeedbackProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/submit" element={<SubmitPage />} />
        <Route path="/submit/success" element={<SubmitSuccessPage />} />
        <Route path="/vote" element={<VoteRequestPage />} />
        <Route path="/vote/classic" element={<VotePage />} />
        <Route path="/vote/elo" element={<EloVotingPage />} />
        <Route path="/vote/success" element={<VoteSuccessPage />} />
        <Route path="/winners/2026" element={<WinnersPage />} />

        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboardPage />} />
      </Routes>
    </FeedbackProvider>
  )
}
